import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from "formik";
import ContactView from "./Contact-view";
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';

const Contact = ({
                     sendContactMail,
                     showGlobalErrorMessage,
                     user,
                     modalContactSlide,
                     slideModalContact
                }) => {
    const [reinit, setReinit] = useState(true);
    const userData = user.user ? user.user.attributes : {};
    const fullName = `${userData.name} ${userData.family_name}`
    const initialValues = {
        fullName: fullName || '',
        email: userData.email || '',
        message: ''
    };

    const validate = values => checkRequiredValues(values, {});

    const handleSubmit = (values, {resetForm}) => {resetForm()};

    const handleDataSubmit = values => () => {
        setReinit(false);  //https://github.com/formium/formik/issues/2369
        sendContactMail(values)
          .then(() => setReinit(true))
          .then(() => slideModalContact())
          .catch((err) => showGlobalErrorMessage(err.message))
    };

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
            enableReinitialize={reinit}
            validateOnChange={true}
            validateOnBlur={false}
        >
            {(formikProps) => (
                <ContactView
                  {...formikProps}
                  onSubmitClick={handleDataSubmit(formikProps.values)}
                  modalContactSlide={modalContactSlide}
                  slideModalContact={slideModalContact}
                />
              )}
        </Formik>
    )
};

Contact.propTypes = {
    values: PropTypes.object,
    user: PropTypes.object
};

export default Contact;
